import { render, staticRenderFns } from "./textAlign.vue?vue&type=template&id=095e3f6e&scoped=true&"
import script from "./textAlign.vue?vue&type=script&lang=js&"
export * from "./textAlign.vue?vue&type=script&lang=js&"
import style0 from "./textAlign.vue?vue&type=style&index=0&id=095e3f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e3f6e",
  null
  
)

export default component.exports